import { render, staticRenderFns } from "./ImageAttrDefault.vue?vue&type=template&id=0fd6d2bc&scoped=true&"
import script from "./ImageAttrDefault.vue?vue&type=script&lang=js&"
export * from "./ImageAttrDefault.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttrDefault.vue?vue&type=style&index=0&id=0fd6d2bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6d2bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
